import { ModalBaseDirective } from '$core/base/_modal.component';
import { convertToContractAddress } from '$core/helpers/address-converter';
import { OldAddress } from '$core/models/old-address';
import { ContractAddress } from '$core/models/contract-address';
import { Pagination } from '$core/models/pagination';
import { AddressesService } from '$core/services/addresses.service';
import { SessionService } from '$core/services/session.service';
import { SwalService } from '$core/shell/swal/swal.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { first, map } from 'rxjs/operators';
import { ManageAddressComponent } from '../manage-address/manage-address.component';

@Component({
  selector: 'app-select-address',
  templateUrl: './select-address.component.html',
  styleUrls: ['./select-address.component.scss'],
})
export class SelectAddressComponent
  extends ModalBaseDirective
  implements OnInit, OnDestroy
{
  public items: Pagination<OldAddress>;
  public selectedItem: OldAddress | ContractAddress;
  public queryParams;
  public isContractAddress = false;
  public filters: any = [
    {
      title: 'ALL',
    },
  ];

  constructor(
    private addressesService: AddressesService,
    private sessionService: SessionService,
    protected modalRef: BsModalRef,
    protected modalService: BsModalService,
    protected translates: TranslateService,
    protected route: ActivatedRoute,
    private router: Router,
    private swalService: SwalService
  ) {
    super(modalRef, modalService, translates);
  }

  public ngOnInit() {
    this.route.queryParams.subscribe((res) => {
      this.queryParams = res;
      this.getItems();
    });
  }

  public ngOnDestroy(): void {
    this.router.navigate([], {
      queryParams: {
        type: null,
      },
      queryParamsHandling: 'merge',
    });
  }

  public isPersonalItemActiveClass(item: OldAddress): boolean {
    return (
      this.selectedItem &&
      String((<OldAddress>this.selectedItem).id) === String(item.id)
    );
  }

  public selectItem(item: OldAddress): void {
    if (this.isContractAddress) {
      this.selectedItem = convertToContractAddress(item);
    } else {
      this.selectedItem = item;
    }

    this.hide('saved');
  }

  public onScroll() {
    if (this.items.next_page_url) {
      this.nextPage(this.items.next_page_url);
    }
  }

  public onSave(item) {
    if (item.is_default) {
      this.updateIsDefault(item.id);
    }
  }

  public createItem() {
    const m = this.modalService.show(ManageAddressComponent, {
      initialState: {
        item: new OldAddress(this.queryParams || {}),
      },
      class: 'modal-lg modal-dialog-centered',
    });
    this.modalService.onHidden
      .pipe(
        first(() => {
          return this.modalService.getModalsCount() === this.selfCount;
        })
      )
      .subscribe((res) => {
        if (res === 'saved') {
          this.items.data.unshift(m.content.item);
          if (m.content.defaultChanged) {
            this.updateIsDefault(m.content.item.id);
          }
          this.selectedItem = m.content.item;
          this.selectItem(m.content.item);
        }
      });
  }

  private updateIsDefault(id) {
    this.items.data.forEach((el) => {
      if (el.id !== id) {
        el.is_default = false;
      } else {
        el.is_default = true;
        const u = this.sessionService.session;
        if (u) {
          u.default_address = el;
          this.sessionService.session = u;
        }
      }
    });
  }

  private async getItems() {
    try {
      this.items = await this.addressesService
        .getItems<OldAddress>(this.queryParams)
        .pipe(
          map((res) => {
            return res;
          })
        )
        .toPromise();
    } catch (error) {
      this.onError(error);
    }
  }

  private async nextPage(url) {
    try {
      const tmpitem: any = await this.addressesService
        .nextPage(url)
        .toPromise();
      tmpitem.data = [...this.items.data, ...tmpitem.data];
      Object.assign(this.items, tmpitem);
    } catch (error) {
      this.onError(error);
    }
  }

  private onError(error) {
    const res: HttpErrorResponse = error;
    const swal = this.swalService.swal;
    swal.icon = 'error';
    swal.title = this.translates.instant('AN_ERROR_HAS_OCCURRED');
    if (res.status === 404) {
      swal.text = this.translates.instant(
        res.error.message || 'ADDRESS_NOT_FOUND'
      );
      swal.fire();
    } else {
      swal.text = res.error
        ? res.error.message || res.error.error
        : res.statusText;
      swal.fire();
    }
  }
}
